var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { SupportedMessageFormats } from "../../../contracts";
import { JSON_RPC } from "../../strings";
import { isFormatMsgPack } from "../isFormatMsgPack";
import { encode } from "@msgpack/msgpack";
const formats = {
    [SupportedMessageFormats[JSON_RPC]]: ({ channel, data, id }) => ({
        jsonrpc: "2.0",
        params: data,
        method: channel,
        id
    })
};
export function RequestFormatter(props, connectionName) {
    const { type } = props, rest = __rest(props, ["type"]);
    return isFormatMsgPack(connectionName) ? encode(formats[type](rest)) : JSON.stringify(formats[type](rest));
}
//# sourceMappingURL=requestFormatter.js.map